import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import loginInfo from "../../components/LoginInfo";
import AuditHistoryView from "../../components/AuditHistoryView";
import OfficialHistoryDetailGrid from "../../components/grids/OfficialHistoryDetailGrid";
import {
  OFFICIAL_HISTORY_ACTIONS,
  OVM_HISTORY_ACTIONS,
  LEGITIMATE_HISTORY_ACTIONS,
  FINANCIAL_HISTORY_ACTIONS,
  INITIATIVE_HISTORY_ACTIONS,
  REQUEST_HISTORY_ACTIONS,
} from "../../components/audit/entityLabels";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

class OverviewHistoryPage extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: "Historie" }]);
  }

  render() {
    const { auth, location } = this.props;
    const path = (location && location.pathname) || "";
    const url = path.replace(`${auth.startUrl}/`, `${auth.startUrl}/api/`);
    const gridName = "overviewHist" + path.replace(/[^a-zA-Z0-9]/g, "_");
    const isOfficial = path.includes("/funkcionari/");
    const SEGMENT_TO_TYPES = {
      funkcionari: ["Official", "Statement"],
      "podpurne-organy": ["Ovm"],
      "opravnene-organy": ["LegitimateAuthority"],
      "financni-instituce": ["FinancialInstitution"],
      spravci: ["InternalUser"],
      administratori: ["InternalUser"],
      podnety: ["Initiative"],
      zadosti: ["Request"],
      napovedy: ["Help"],
    };
    const SEGMENT_TO_ACTIONS = {
      funkcionari: OFFICIAL_HISTORY_ACTIONS,
      "podpurne-organy": OVM_HISTORY_ACTIONS,
      "opravnene-organy": LEGITIMATE_HISTORY_ACTIONS,
      "financni-instituce": FINANCIAL_HISTORY_ACTIONS,
      podnety: INITIATIVE_HISTORY_ACTIONS,
      zadosti: REQUEST_HISTORY_ACTIONS,
      // spravci/administratori/napovedy → full list (no entry)
    };
    const segmentKey = Object.keys(SEGMENT_TO_TYPES).find((k) => path.includes(`/${k}/`));
    const allowedEntityTypes = segmentKey ? SEGMENT_TO_TYPES[segmentKey] : undefined;
    const allowedActions = segmentKey ? SEGMENT_TO_ACTIONS[segmentKey] : undefined;
    const showOwner = !allowedEntityTypes || allowedEntityTypes.length > 1;
    return (
      <div>
        <AuditHistoryView
          auth={auth}
          grid={OfficialHistoryDetailGrid}
          gridName={gridName}
          url={url}
          showOwner={showOwner}
          showNote={isOfficial}
          allowedEntityTypes={allowedEntityTypes}
          allowedActions={allowedActions}
        />
        <div style={{ marginTop: 12 }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() => this.props.goBack()}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, goBack })(loginInfo(OverviewHistoryPage));
